module.exports = __webpack_public_path__ + "img/maigret-y-la-vieja-dama.c555d1e5.jpg";